import axios from 'axios';

export const restAPIClient = axios.create({
    baseURL: process.env.REACT_APP_REST_API_ENDPOINT
})